import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';

const HotelImportantInformation = ({ content = '' }) => {
  if (!content) {
    return null;
  }

  return (
    <div className="margin-2-t">
      <Heading level={3} variant="sans-medium-bold" className="margin-1-b">
        Important information
      </Heading>
      <div
        className="body"
        // eslint-disable-next-line react/no-danger -- content is sourced from trusted internal API
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </div>
  );
};

HotelImportantInformation.propTypes = {
  content: PropTypes.string,
};

export default HotelImportantInformation;
